import {Directive} from '@angular/core';
import {NgControl} from '@angular/forms';

@Directive({
    selector: '[ngModel]',
    host: {
        '(blur)': 'onBlur($event)'
    }
})
export class ValidateOnBlurDirective {

    constructor(private formControl: NgControl) {
    }

    onBlur() {
        this.formControl.control.updateValueAndValidity();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/validation/validate.on.blur.directive.ts